import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Row, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { actions } from '@/core/store';



const Home = () => {
	//Start hidden so plugin pages that resolve late don't flash this page while loading
	const [visible, setVisible] = useState(false),
		  dispatch             = useDispatch();

	useEffect(() => {
		//Clear any title left over from a previously viewed page
		dispatch(actions.layout.setTitle(''));

		const timer = setTimeout(() => setVisible(true), 1000);
		return () => clearTimeout(timer);
	}, []);

	return (

		<Row className="ts_home_content_container">
			<Col xs={24}>
				<div className={'ts_portal_card ts_notfound_card' + (visible ? ' ts_notfound_card--visible' : '')}>
					<Typography.Title level={4}><ExclamationCircleOutlined /> Not Found</Typography.Title>
					<Typography>
						Looks like you took a wrong turn. Click the {import.meta.env.VITE_COMPANY_NAME} logo to go home, or enter a new URL.
					</Typography>
				</div>
			</Col>
		</Row>

	);
};


export default Home;
